import "./plugins/headers-cards/headers-cards.js";
import "./plugins/copy-code/copy-code.js";
import "./plugins/navbar-collapse/navbar-collapse.js";
import "./plugins/pagination/pagination.js";
import "./plugins/search/search.js";
import "./plugins/site-title/site-title.js";
import "//cdn.jsdelivr.net/npm/docsify/lib/plugins/search.min.js";
import "//cdn.jsdelivr.net/npm/docsify-pagination/dist/docsify-pagination.min.js";
